document.addEventListener('DOMContentLoaded', function() {

  // Basis swiper + mogelijk lightgallery 
  
  document.querySelectorAll('.block-news-carousel').forEach(carousel => {
    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    const swiperId = carousel.id;

    const swiper = new Swiper(carousel.querySelector('.swiper-container'), {
      grabCursor: true,
      spaceBetween: 16,
      slidesPerView: 'auto',
      // centeredSlides: true,
      autoHeight: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 20,
        },
        1400: {
          spaceBetween: 20,
        },
        1500: {
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          // if( lightGallery !== undefined ) {
          //   const $lgSwiper = document.getElementById(swiperId);
          //   const lg = lightGallery($lgSwiper, {
          //     selector: '[data-src]'
          //   });
          //   $lgSwiper.addEventListener('lgBeforeClose', () => {
          //     swiper.slideTo(lg.index, 0)
          //   });
          // }
        },
      }
    });

  });

});